import { ROUTES } from "@/constants/Routes";
import { ATTRIBUTION_NAMES } from "@/constants/User";
import { hasAttribution } from "@/utils/permissions";
import { useUserStore } from "@/store/useUserStore";
import { Alert, Box, Link, Typography } from "@mui/material";
import section_example from "@/assets/images/section_example.png";
import Image from "next/image";
import { blueGrey } from "@mui/material/colors";

export function SectionsManagement() {
	const canManage = useUserStore(
		({ attributions, isAdmin }) =>
			(hasAttribution(attributions ?? [], ATTRIBUTION_NAMES.SOCIO_JURIDICO) ||
			hasAttribution(attributions ?? [], ATTRIBUTION_NAMES.ETICO)) || isAdmin
	);

	return (
		<>
			<Alert severity='warning'>
				Somente administradores e especialistas podem gerenciar as seções
			</Alert>

			<Typography variant='body2'>
				{canManage ? (
					<Link href={ROUTES.SECTION.REGISTER}>Seções</Link>
				) : (
					<span style={{ fontWeight: 600 }}>Seções</span>
				)}{" "}
				são um dos requisitos para que os questionários AIA e EPS possam ser
				cadastrados!
			</Typography>

			<Typography variant='body2'>
				Seções tem questões vinculadas no momento de criação dos{" "}
				{canManage ? (
					<Link href={ROUTES.QUESTIONNAIRE.REGISTER.AIA}>
						questionários AIA
					</Link>
				) : (
					<span style={{ fontWeight: 600 }}>questionários AIA</span>
				)}{" "}
				e criação dos{" "}
				{canManage ? (
					<Link href={ROUTES.QUESTIONNAIRE.REGISTER.EPS}>
						questionários EPS
					</Link>
				) : (
					<span style={{ fontWeight: 600 }}>questionários EPS</span>
				)}
				. Essa abordagem foi elaborada de forma que seções e perguntas possam
				ser reaproveitados em diferentes versões de questionários.
			</Typography>

			<Typography variant='body2'>
				O vínculo entre as seções e questões só existe no contexto do
				questionário em criação, ou seja, as perguntas{" "}
				<span style={{ fontWeight: 600 }}>
					não são diretamente vinculadas às seções
				</span>
				, os questionários são uma{" "}
				<span style={{ fontWeight: 600 }}>cópia</span> dos dados de seções,
				perguntas e princípios (questionários AIA).
			</Typography>

			<Box>
				<Image
					src={section_example}
					loading='lazy'
					alt='Exemplo de representação visual de seção'
					style={{ borderRadius: "0.25rem" }}
					width={340}
				/>
				<Typography
					component={"p"}
					variant='caption'
					color={blueGrey[500]}
					sx={{ marginTop: -0.2 }}
				>
					Exemplo de representação visual de seção
				</Typography>
			</Box>

			<Typography variant='body2'>
				Para fins de melhor identificação visual, cada seção possui uma cor
				própria.
			</Typography>

			<Typography variant='body2'>
				Seções podem ser{" "}
				{canManage ? (
					<Link href={ROUTES.SECTION.REGISTER}>registradas</Link>
				) : (
					<span style={{ fontWeight: 600 }}>registradas</span>
				)}
				,{" "}
				{canManage ? (
					<Link href={ROUTES.SECTION.EDIT}>alteradas</Link>
				) : (
					<span style={{ fontWeight: 600 }}>alteradas</span>
				)}{" "}
				e{" "}
				{canManage ? (
					<Link href={ROUTES.SECTION.EDIT}>removidas</Link>
				) : (
					<span style={{ fontWeight: 600 }}>removidas</span>
				)}
				. Alterar dados das seções não influencia nos questionários já
				cadastrados no sistema. Isto serve para manter consistência de dados e
				versões nos questionários publicadas e vinculados às aplicações das
				organizações.
			</Typography>
		</>
	);
}
